// extracted by mini-css-extract-plugin
module.exports = {"margin-top":"Card_margin-top__1FbM5","margin-bottom":"Card_margin-bottom__2mlCX","shadow":"Card_shadow__YNoZM"};